// extracted by mini-css-extract-plugin
module.exports = {"nav":"_3Troc8","navItem":"_1QBBVU","brand":"_2wMHzt","active":"_2TxD0M"};